import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressIndicator = ({ currentStep, totalSteps }) => {
  return (
    <div className="w-full max-w-md mx-auto mb-8">
      <div className="flex items-center justify-between">
        {Array.from({ length: totalSteps }, (_, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < currentStep;
          const isCurrent = stepNumber === currentStep;
          
          return (
            <React.Fragment key={stepNumber}>
              <div className="flex flex-col items-center">
                <div
                  className={`
                    w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold
                    transition-all duration-300 ease-out
                    ${isCompleted 
                      ? 'bg-success text-success-foreground' 
                      : isCurrent 
                        ? 'bg-primary text-primary-foreground' 
                        : 'bg-muted text-muted-foreground'
                    }
                  `}
                >
                  {isCompleted ? (
                    <Icon name="Check" size={16} />
                  ) : (
                    stepNumber
                  )}
                </div>
                <span className={`
                  text-xs mt-2 font-medium
                  ${isCurrent ? 'text-primary' : 'text-muted-foreground'}
                `}>
                  {stepNumber === 1 && 'Account'}
                  {stepNumber === 2 && 'Verify'}
                  {stepNumber === 3 && 'Profile'}
                </span>
              </div>
              
              {stepNumber < totalSteps && (
                <div className={`
                  flex-1 h-0.5 mx-4 transition-all duration-300 ease-out
                  ${isCompleted ? 'bg-success' : 'bg-muted'}
                `} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressIndicator;